export default {
    courseResult:[],
    courseDtlResult : null
}